export default "__VITE_ASSET__CUWz0Y81__"